import Clipboard from 'clipboard';

let clipboard;

export const copy = {
  mounted(el, binding) {
    try {
      const { cpValue, successFn, errorFn } = binding.value;
      if (!cpValue) return;
      el.setAttribute('data-clipboard-text', cpValue);
      nextTick(() => {
        clipboard = new Clipboard(el);
        clipboard.on('success', () => {
          console.warn('Copy success');
          successFn?.();
        });
        clipboard.on('error', () => {
          console.warn('Copy error');
          errorFn?.();
        });
      });
    } catch (error) {
      console.log(error);
    }
  },
  unmounted() {
    // 组件销毁时必须销毁 clipboard，否则下次new Clipboard的时候会触发2次success回调
    clipboard?.destroy();
  },
};
